let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eH8We")).then(() => parcelRequire('kGwrf'));